<template>
    <div>
        <form role="form">
            <div class="row">
                <div class="col-md-12">
                    <div class="box box-primary">
                        <div class="box-header with-border">
                            <h3 class="box-title">
                                Licence
                                <select v-model="anneeSelected">
                                    <option v-for="annee in this.anneesDispo()"
                                            :value="annee">{{annee}}
                                    </option>
                                </select>
                            </h3>

                            <div class="pull-right">
                                <span v-for="licence in getClub.licences">
                                        <a class="name"
                                           href="#"
                                           @click.prevent="anneeSelected=licence.annee">
                                            {{ licence.annee }}
                                        </a>
                                    &nbsp;-&nbsp;
                                </span>
                            </div>
                        </div>

                        <div class="box-body" v-if="!licenceSelected">
                            <div class="row">
                                <button type="button" @click.prevent="addNewLicence()" class="center-block btn btn-primary btn-flat">
                                    Ajouter une licence {{anneeSelected}}
                                </button>
                            </div>
                        </div>

                        <div class="box-body" v-if="licenceSelected">
                            <div class="row">
                                <div class="input-daterange" id="dataRange">
                                    <div class="form-group col-md-3 "
                                         :class="{'has-warning': warningMessageDate }">
                                        <label>Date de réception de la compo club {{licenceSelected.annee}}:</label>
                                        <div class="input-group date ">
                                            <div class="input-group-addon">
                                                <i class="fa fa-calendar"></i>
                                            </div>

                                            <masked-input type="text"
                                                          v-model="licenceSelected.date_inscription"
                                                          v-validate="'date_format:DD/MM/YYYY'"
                                                          :mask="[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]"
                                                          :guide="true"
                                                          :keepCharPositions="true"
                                                          :showMask="true"
                                                          name="date_inscription"
                                                          class="form-control pull-right datepicker"
                                                          id="datepicker2">
                                            </masked-input>
                                        </div>
                                        <span v-show="warningMessageDate"
                                              class="help-block"> Cette date n'est pas au bon format</span>
                                    </div>

                                    <div class="form-group col-md-3 "
                                         :class="{'has-warning': warningMessageDate }">
                                        <label>Date de payement {{licenceSelected.annee}}:</label>
                                        <div class="input-group date ">
                                            <div class="input-group-addon">
                                                <i class="fa fa-calendar"></i>
                                            </div>

                                            <masked-input type="text"
                                                          v-model="licenceSelected.date_payement"
                                                          v-validate="'date_format:DD/MM/YYYY'"
                                                          :mask="[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]"
                                                          :guide="true"
                                                          :keepCharPositions="true"
                                                          :showMask="true"
                                                          name="date_payement"
                                                          class="form-control pull-right datepicker"
                                                          id="datepicker3">
                                            </masked-input>
                                        </div>
                                        <span v-show="warningMessageDate"
                                              class="help-block"> Cette date n'est pas au bon format</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label>Composition club:</label>
                                        <div class="radio">
                                            <label>
                                                <input type="radio"
                                                       v-model="licenceSelected.inscription"
                                                       name="inscription"
                                                       id="inscription1" value="1">
                                                Reçue
                                            </label>
                                        </div>
                                        <div class="radio">
                                            <label>
                                                <input type="radio"
                                                       v-model="licenceSelected.inscription"
                                                       name="inscription"
                                                       id="inscription2" value="0">
                                                Non-reçue
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label>Payement :</label>
                                        <div class="radio">
                                            <label>
                                                <input type="radio"
                                                       v-model="licenceSelected.payement"
                                                       name="payementLicence"
                                                       id="payementLicence1" value="1">
                                                Reçue
                                            </label>
                                        </div>
                                        <div class="radio">
                                            <label>
                                                <input type="radio"
                                                       v-model="licenceSelected.payement"
                                                       name="payementLicence"
                                                       id="payementLicence2" value="0">
                                                Non-reçue
                                            </label>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <button
                                            type="button"
                                            @click="sendForm()"
                                            class="btn btn-primary margin pull-right">
                                        {{ licenceSelected.id==0 ? "Ajouter" : "Mettre à jour" }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <form role="form">
            <div class="row">
                <div class="col-md-12">
                    <div class="box box-primary">
                        <div class="box-header with-border">
                            <h3 class="box-title">Licences</h3>
                        </div>
                        <div class="box-body">
                            <b-table
                                    id="tableListingLicencesClub"
                                    responsive bordered striped hover
                                    :items="getClub.licences"
                                    :fields="columns"
                                    :current-page="pagination_meta.current_page"
                                    :per-page="pagination_meta.per_page"
                                    :empty-text="'Aucun résultat'"
                                    :empty-filtered-text="'Aucun résultat'"
                                    :sort-compare="sortCompareAdvanced"
                                    :sort-by.sync="sortBy"
                                    :sort-desc.sync="sortDesc"
                                    foot-clone
                                    show-empty
                            >
                                <template slot="action" slot-scope="row">
                                    <button @click.prevent="licenceSelected=row.item" class="btn btn-box-tool">
                                        <i class="fa fa-pencil"></i>
                                    </button>
                                    <button @click.prevent="deleteLicence(row.item.id)" class="btn btn-box-tool">
                                        <i class="fa fa-remove"></i>
                                    </button>
                                </template>
                            </b-table>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>

    import Datepicker from 'vuejs-datepicker';
    import {mapGetters, mapActions} from 'vuex'
    import {ErrorBag} from 'vee-validate';

    var $ = require('jquery');
    var variables = require('../../../assets/js/variables')
    var _ = require('underscore')
    var moment = require('moment')

    export default {
        data() {
            return {
                sortBy:'annee',
                sortDesc:true,
                licenceSelected: null,
                anneeSelected: null,
                dataTableLicencesClub: null,
                warningMessageDate: false,
                disabledBtn: false,
                pagination_meta: {
                    current_page: 1,
                    from: 1,
                    last_page: 1,
                    path: "",
                    per_page: 20,
                    to: 1,
                    total: 1
                },
                columns: [
                    {
                        label: 'Année',
                        sortable: true,
                        key: 'annee'
                    },
                    {
                        label: 'Composition club',
                        sortable: true,
                        key: 'date_inscription'
                    },
                    {
                        label: 'Payement',
                        sortable: true,
                        key: 'date_payement'
                    },
                    {
                        label: 'Action',
                        sortable: true,
                        key: 'action'
                    },
                ]
            }
        },
        computed: {
            ...mapGetters({
                getClub: 'getClub',
                getRoute: 'getRoute',
            }),

        },
        methods: {
            ...mapActions({}),
            anneesDispo: function () {
                let annees = [];
                let annee = 1990;
                while (annee < (moment().year() + 3)) {
                    annees.push(annee);
                    annee++
                }
                return annees.reverse();
            },
            constructForm: function () {
                return JSON.stringify({
                    "id_club": this.licenceSelected.id_club,
                    "id": this.licenceSelected.id,
                    "date_inscription": this.licenceSelected.date_inscription,
                    "date_payement": this.licenceSelected.date_payement,
                    "inscription": this.licenceSelected.inscription,
                    "payement": this.licenceSelected.payement,
                    "annee": this.licenceSelected.annee,
                })
            },
            flatten: function (obj) {
                var root = {};
                (function tree(obj, index) {
                    var suffix = toString.call(obj) == "[object Array]" ? "]" : "";
                    for (var key in obj) {
                        if (!obj.hasOwnProperty(key)) continue;
                        root[index + key + suffix] = obj[key];
                        if (toString.call(obj[key]) == "[object Array]") tree(obj[key], index + key + suffix + "[");
                        if (toString.call(obj[key]) == "[object Object]") tree(obj[key], index + key + suffix + ".");
                    }
                })(obj, "");
                return root;
            },
            sortCompareAdvanced: function (a, b, key) {
                if (typeof a[key] === 'number' && typeof b[key] === 'number') {
                    // If both compared fields are native numbers
                    return a[key] < b[key] ? -1 : (a[key] > b[key] ? 1 : 0)
                } else {
                    // Stringify the field data and use String.localeCompare
                    return (this.flatten(a)[key]).toString().localeCompare((this.flatten(b)[key]).toString(), undefined, {
                        numeric: true
                    })
                }
            },

            sendForm: function () {
                this.disabledBtn = true;
                let self = this;
                //Si c'est un update de licence
                if (this.licenceSelected.id != 0) {
                    this.$http.put(this.getRoute('Secretariat.licenceclub.update') + this.licenceSelected.id, this.constructForm()).then(function (response) {
                        self.$noty.success("La licence du club a bien été modifiée")
                        this.disabledBtn = false
                        this.getClub.licences = response.body;
                    }, (response) => {
                        self.$noty.error("Erreur dans la modification de la licence")
                        this.disabledBtn = false
                    });
                } else {
                    this.$http.post(this.getRoute('Secretariat.licenceclub.store'), this.constructForm()).then(function (response) {
                        self.$noty.success("La licence du club a bien été ajoutée")
                        this.licenceSelected = response.body['licence']
                        this.disabledBtn = false
                        this.getClub.licences = response.body['allLicences'];
                    }, (response) => {
                        self.$noty.error("Erreur dans l'ajout de la licence")
                        this.disabledBtn = false
                    });
                }
            },
            deleteLicence: function ($id_licence) {
                this.$http.delete(this.getRoute('Secretariat.licenceclub.destroy') + $id_licence).then(function (response) {
                    this.$noty.success("La licence du club a bien été supprimée")
                    this.disabledBtn = false
                    this.getClub.licences = response.body;
                    this.licenceSelected = _.first(this.getClub.licences)

                }, (response) => {
                    this.$noty.error("Erreur dans la suppression de la licence")
                    this.disabledBtn = false
                });
            },
            formatDate: function (value, ftmIn, fmtOut) {
                if (value == null) return ''
                fmtOut = (typeof fmtOut == 'undefined') ? 'DD/MM/YYYY HH:mm' : fmtOut
                return moment(value, ftmIn).format(fmtOut)
            },
            addNewLicence: function () {
                this.isAddingNewLicence = true
                this.licenceSelected = {
                    id: 0,
                    id_club: this.getClub.id,
                    inscription: 1,
                    payement: 1,
                    date_inscription: moment().format('DD/MM/YYYY'),
                    date_payement: moment().format('DD/MM/YYYY'),
                    annee: this.anneeSelected
                }
                this.warningMessageDate = false
                this.licenceAlreadyExist = null
            },
            refreshListings: function () {
                this.dataTableLicencesClub = $("#licencesClub").DataTable({
                    language: variables.dt_french(),
                    "paging": true,
                    "ordering": true,
                    "info": true,
                    "autoWidth": true,
                });
            },

        },
        watch: {
            licenceSelected: function (value) {
                if (value)
                    this.anneeSelected = this.licenceSelected.annee;
            },
            anneeSelected: function (value) {
                this.licenceSelected = _.find(this.getClub.licences, function (licence) {
                    return moment(licence.annee, "YYYY-MM-DD").year() == value
                });
            }
        },
        mounted: function () {
            var these = this
            //LicenceActive
            // this.licenceSelected =
            //     _.find(this.getClub.licences, function (licence) {
            //         return moment(licence.annee, "YYYY-MM-DD").year() == moment().year()
            //     });
            this.anneeSelected = moment().year();

            this.$nextTick(function () {
                setTimeout(function () {
                    these.refreshListings()
                }, 1000)
            })

        },
        filters: {},
        components: {}
    }
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Club/FormLicenceClub.vue